import axios from "./configAxios";

export const getTerminalListApi = async () => {
    return await axios.get(`/list/`)
}